var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 12H15.3333C14.2288 12 13.3333 12.8954 13.3333 14C13.3333 15.1045 14.2288 16 15.3333 16H16.6667C17.7712 16 18.6667 16.8954 18.6667 18C18.6667 19.1045 17.7712 20 16.6667 20H13.3333M16 10.6666V12M16 20V21.3333M24 16H24.0133M7.99999 16H8.01332M2.66666 10.9333V21.0666C2.66666 22.5601 2.66666 23.3069 2.95731 23.8773C3.21296 24.379 3.62091 24.787 4.12268 25.0426C4.69311 25.3333 5.43984 25.3333 6.93332 25.3333H25.0667C26.5601 25.3333 27.3069 25.3333 27.8773 25.0426C28.3791 24.787 28.7871 24.379 29.0427 23.8773C29.3333 23.3069 29.3333 22.5601 29.3333 21.0666V10.9333C29.3333 9.43983 29.3333 8.69308 29.0427 8.12265C28.7871 7.62089 28.3791 7.21295 27.8773 6.95728C27.3069 6.66663 26.5601 6.66663 25.0667 6.66663H6.93332C5.43986 6.66663 4.69311 6.66663 4.12268 6.95728C3.62092 7.21293 3.21296 7.62088 2.95731 8.12265C2.66666 8.69308 2.66666 9.43981 2.66666 10.9333ZM24.6667 16C24.6667 16.3681 24.3681 16.6666 24 16.6666C23.6319 16.6666 23.3333 16.3681 23.3333 16C23.3333 15.6318 23.6319 15.3333 24 15.3333C24.3681 15.3333 24.6667 15.6318 24.6667 16ZM8.66666 16C8.66666 16.3681 8.36818 16.6666 7.99999 16.6666C7.6318 16.6666 7.33332 16.3681 7.33332 16C7.33332 15.6318 7.6318 15.3333 7.99999 15.3333C8.36818 15.3333 8.66666 15.6318 8.66666 16Z",
    stroke: "#208C56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyHeaderIcon);
export default __webpack_public_path__ + "static/media/money-header-icon.f27485bf850a22601169aa1786cb8037.svg";
export { ForwardRef as ReactComponent };